import getCookieDomain from './getCookieDomain';

/**
 * Returns default cookie domain
 * @param context
 * @returns
 */
function getDefaultCookieDomain(context) {
  return getCookieDomain(undefined, context);
}
export default getDefaultCookieDomain;